<template>
  <div 
    v-loading="loading || programLoading"
    class="subprogram-nba-summary app-content-page" 
  >
    <!-- Teams -->
    <app-subprogram-nba-summary-teams
      v-if="program"
    />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import SubprogramNbaSummaryTeams from '@modules/subprogram/nba/components/subprogram-nba-summary-teams.vue';

  export default {
    name: 'app-subprogram-nba-summary',

    components: {
      [SubprogramNbaSummaryTeams.name]: SubprogramNbaSummaryTeams,
    },
  
    async mounted () {
      await this.$nextTick();
      await this.doLoad({ subpropertyId: this.subpropertyId, programId: this.programId, subprogramId: this.subprogramId});
    },

    computed: {
      ...mapGetters({
        program: 'subprogram/nba/program',
        programLoading: 'subprogram/nba/loading',
        subprogram: 'subprogram/nba/subprogram',
        loading: 'subprogram/nba/summary/loading',
        subpropertyId: 'subprogram/nba/subpropertyId',
        programId: 'subprogram/nba/programId',
        subprogramId: 'subprogram/nba/subprogramId'
      }),
    },
    
    methods: {
      ...mapActions({
        doLoad: 'subprogram/nba/summary/doLoad',
      })
    },
  }

</script>

<style lang="scss" scoped>
.subprogram-nba-summary {
  padding: 40px 64px;
}
</style>